import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Paper,
    IconButton,
    Button
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import api from '../../api/api'; // ? Use shared Axios instance

const DivisionList = () => {
    const [divisions, setDivisions] = useState([]);
    const token = localStorage.getItem("access");

    const fetchDivisions = async () => {
        if (!token) return;

        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const response = await api.get('/api/users/divisions/', config); // ? use `api` instead of `axios`
            setDivisions(response.data);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch divisions.',
            });
        }
    };

    useEffect(() => {
        fetchDivisions();
    }, [token]);

    const handleDelete = async (id) => {
        if (!token) return;

        const confirmResult = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        });

        if (confirmResult.isConfirmed) {
            try {
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };
                await api.delete(`/api/users/divisions/${id}/`, config); // ? use `api` instead of `axios`

                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The division has been deleted.',
                });

                fetchDivisions();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to delete the division.',
                });
            }
        }
    };

    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                onClick={fetchDivisions}
                style={{ marginBottom: '20px' }}
            >
                Refresh List
            </Button>
            <Box padding={8}>
                <h3>Divisions Name</h3>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ backgroundColor: '#0D1B2A', color: '#FFFFFF' }}>ID</TableCell>
                                <TableCell style={{ backgroundColor: '#2b466e', color: '#ffffff' }}>Division Name</TableCell>
                                <TableCell style={{ backgroundColor: '#2b466e', color: '#ffffff' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {divisions.map((division) => (
                                <TableRow key={division.id}>
                                    <TableCell style={{ backgroundColor: '#0D1B2A', color: '#FFFFFF' }}>{division.id}</TableCell>
                                    <TableCell>{division.name}</TableCell>
                                    <TableCell>
                                        <IconButton
                                            color="secondary"
                                            onClick={() => handleDelete(division.id)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </div>
    );
};

export default DivisionList;
